import ViewBase from "../../../../framework/core/mvvm/view_base";


const { ccclass, property } = cc._decorator;




@ccclass
export default class SlotRuleVIew extends ViewBase {


    @property(cc.Sprite)
    iconAtlas: cc.Sprite[] = []

    @property(cc.Node)
    grid: cc.Node = null

    @property(cc.Node)
    ex: cc.Node = null

    @property(cc.Label)
    wildDes: cc.Label = null

    @property(cc.Label)
    forwardDes: cc.Label = null

    @property(cc.PageView)
    pageView: cc.PageView = null

    @property(cc.Button)
    btnLeft: cc.Button = null

    @property(cc.Button)
    btnRight: cc.Button = null

    furiteBeishu: number[][] = [[200, 70, 10], [200, 60, 10], [160, 50, 10], [120, 40, 8], [120, 40, 8], [100, 30, 7], [80, 25, 7], [60, 20, 7], [40, 15, 5], [40, 15, 5]]

    initFruit = false

    onInit() { }
    onShow() {
        this.initFruitBeishu()
    }

    initFruitBeishu() {
        if (this.initFruit) {
            return
        }
        for (let i = 0; i < this.iconAtlas.length; i++) {
            let obj: cc.Node = this.instantiateNode(this.ex, this.grid)
            obj.getChildByName("Icon").getComponent(cc.Sprite).spriteFrame = this.iconAtlas[i].spriteFrame
            obj.getChildByName("Icon").getComponent(cc.Sprite).sizeMode = cc.Sprite.SizeMode.TRIMMED
            obj.getChildByName("Reward1").getComponent(cc.Label).string = this.furiteBeishu[i][0] + ""
            obj.getChildByName("Reward2").getComponent(cc.Label).string = this.furiteBeishu[i][1] + ""
            obj.getChildByName("Reward3").getComponent(cc.Label).string = this.furiteBeishu[i][2] + ""
        }
        this.initFruit = true
    }
    instantiateNode(node, parent, name?): cc.Node {
        let obj: cc.Node = cc.instantiate(node);
        obj.parent = parent
        obj.x = 0
        obj.y = 0
        obj.angle = 0
        obj.name = name || "clone"
        obj.active = true
        return obj
    }

    arrowBtnDeal(index, all) {
        this.setBtnGrey(this.btnLeft, index == 0)
        this.setBtnGrey(this.btnRight, index == all - 1)
    }

    setBtnGrey(btn: cc.Button, grey: boolean) {
        btn.interactable = !grey
        btn.enableAutoGrayEffect = grey
    }




}
